import React from 'react'

import './Introduction.css'

class Introduction extends React.Component {
  render() {

    var imgRatio = this.props.isMobileSize ? { minHeight: 450, maxHeight: 800 } : { minHeight: 400, maxHeight: 500 };

    return (
      <div>
        <div id="navigation" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="overlay"></div>
              <img class="d-block w-100" style={imgRatio} src="/static/images/introduction/introduction-1.jpg" />
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <h1 className="text-center text-uppercase font-weight-light">Votre 1ère session Bik'Indoor</h1>
          <p className="text-center lead">Il est important de bien préparer cette première séance afin de profiter de cette expérience inoubliable !</p>
        </div>
        <div className="container pt-5">
          <div className="row align-items-center">
            <div className="col-md-auto">
              <img className="round-image" src="/static/images/introduction/introduction-2.jpg" />
            </div>
            <div className="col">
              <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Réservation de votre séance</h1>
              <p className="lead">Afin de vous garantir une expérience optimale, chaque participant est invité à réserver son vélo à l’avance, jusqu’à une heure avant le début de la séance. La réservation s’effectue en toute simplicité, directement au club, par téléphone ou via votre application mobile une fois votre inscription finalisée.</p>
              <p className="lead">Lors de votre réservation, vous avez la liberté de sélectionner l’emplacement de votre vélo au sein du studio, sous réserve de disponibilité, pour une expérience pleinement personnalisée dès votre arrivée.</p>
            </div>
          </div>
          <div className="row align-items-center mt-4">
            <div className="col-md-auto">
              <img className="round-image" src="/static/images/introduction/introduction-3.jpg" />
            </div>
            <div className="col">
              <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Déroulement de votre séance</h1>
              <p className="lead">Afin de vous offrir une expérience optimale, nous vous invitons à effectuer votre check-in idéalement 15 minutes avant le début de la session. Vous serez alors accueilli et accompagné par votre coach, qui prendra le temps de vous guider dans les réglages personnalisés de votre vélo et de vous présenter le déroulement de la séance.</p>
              <p className="lead">Nos sessions sont conçues pour s’adapter à tous les niveaux. Il est donc essentiel d’informer votre coach de toute limitation physique ou blessure éventuelle, afin de vous garantir un encadrement sécurisé, adapté et parfaitement personnalisé.</p>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
export default Introduction;